import moment from 'moment';

import type {FormFieldType} from 'nutshell-graphql-types';
import type {
    GetMcfxForms_mcfxForms_edges_node as McfxForm,
    GetMcfxForms_mcfxForms_edges_node_wfForm_publishedVersion_fields as Field,
} from 'nutshell-graphql-types';

import type {FormFieldSchema} from '../../core/nutshell-fields/types';

export const getLastSubmittedTime = (date?: number | null) => {
    if (!date) {
        return 'No submissions yet';
    }

    const formattedTimestamp = moment.unix(date).format('LL');

    return `Last submitted ${formattedTimestamp}`;
};

export const getNumSubmissions = (mcfxForm: McfxForm) => {
    if (mcfxForm.wfForm && mcfxForm.wfForm.status === 'NOT_ACTIVATED') {
        return mcfxForm.submissions.totalCount;
    } else if (mcfxForm.wfForm) {
        return mcfxForm.wfForm.numSubmissions;
    } else {
        return 0;
    }
};

export const getSubmissionCountText = (numSubmissions: number): string => {
    return `${numSubmissions.toLocaleString()} submission${numSubmissions === 1 ? '' : 's'}`;
};

// TODO add more types here
export const translateFieldTypeToHumanReadable = (fieldType: FormFieldType): string => {
    switch (fieldType) {
        case 'INPUT':
        default:
            return 'Input field';
    }
};

export const getPreviewTitle = (field: Field, formSchema: FormFieldSchema) => {
    const schemaFields = formSchema ? formSchema.properties : undefined;

    if (!field.isIgnored && field.fieldName && schemaFields && schemaFields[field.fieldName]) {
        // @ts-expect-error
        return schemaFields[field.fieldName].label;
    }

    return field.inputName;
};

export const getPreviewSubtitle = (
    field: Field,
    formSchema: FormFieldSchema
): string | null | undefined => {
    const schemaFields = formSchema ? formSchema.properties : undefined;

    if (field.isIgnored) {
        return 'Ignored';
    }

    if (field.fieldName && schemaFields && schemaFields[field.fieldName]) {
        // @ts-expect-error
        const isCustom = schemaFields[field.fieldName].isCustomField;

        return isCustom ? translateFieldTypeToHumanReadable(field.type) : undefined;
    }
};
